import repositories from '..';

const resource = '/integration/menu';

export default {
  getInitData: (data: any) => repositories.get(`${resource}/data/init?moduleId=${data}`),
  getPreviewMenu: (data: any) => repositories.get(`${resource}/preview?moduleId=${data}`),
};
